import { Injectable } from '@angular/core';
import { SessionStorageFields } from '@shared/config/session-storage.config';
import { toBoolean } from '@shared/utils/validators';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  public static setMsalSilentAttempt(value: boolean) {
    sessionStorage.setItem(
      SessionStorageFields.MSAL_SILENT_ATTEMPT,
      value.toString()
    );
  }

  public static getMsalSilentAttempt(): boolean {
    const value = sessionStorage.getItem(
      SessionStorageFields.MSAL_SILENT_ATTEMPT
    );

    return toBoolean(value);
  }

  public static clearMsalSilentAttempt(): void {
    sessionStorage.removeItem(SessionStorageFields.MSAL_SILENT_ATTEMPT);
  }

  public static setMsalRedirectFailed(value: boolean) {
    sessionStorage.setItem(
      SessionStorageFields.MSAL_REDIRECT_FAILED,
      value.toString()
    );
  }

  public static getMsalRedirectFailed(): boolean {
    const value = sessionStorage.getItem(
      SessionStorageFields.MSAL_REDIRECT_FAILED
    );

    return toBoolean(value);
  }

  public static clearMsalRedirectFailed(): void {
    sessionStorage.removeItem(SessionStorageFields.MSAL_REDIRECT_FAILED);
  }

  public static getMsalRedirectBootAttempts(): number {
    const value = sessionStorage.getItem(
      SessionStorageFields.MSAL_REDIRECT_BOOT_ATTEMPTS
    );
    const attempts = Number(value);

    return Number.isFinite(attempts) ? attempts : 0;
  }

  public static incrementMsalRedirectBootAttempts(): number {
    const attempts = SessionStorageService.getMsalRedirectBootAttempts() + 1;
    sessionStorage.setItem(
      SessionStorageFields.MSAL_REDIRECT_BOOT_ATTEMPTS,
      attempts.toString()
    );

    return attempts;
  }

  public static clearMsalRedirectBootAttempts(): void {
    sessionStorage.removeItem(SessionStorageFields.MSAL_REDIRECT_BOOT_ATTEMPTS);
  }

  public static setMsalReturnUrl(url: string): void {
    sessionStorage.setItem(SessionStorageFields.MSAL_RETURN_URL, url);
  }

  public static getMsalReturnUrl(): string | null {
    return sessionStorage.getItem(SessionStorageFields.MSAL_RETURN_URL);
  }

  public static clearMsalReturnUrl(): void {
    sessionStorage.removeItem(SessionStorageFields.MSAL_RETURN_URL);
  }

  private static readonly MSAL_TEMP_CACHE_PREFIX = 'msal.';
  private static readonly MSAL_CACHED_RESPONSE_KEY_SUFFIX = '.urlHash';

  /** Whether MSAL has cached a redirect response hash pending to be processed. */
  public static hasMsalCachedRedirectResponse(): boolean {
    return Object.keys(sessionStorage).some(
      key =>
        key.startsWith(SessionStorageService.MSAL_TEMP_CACHE_PREFIX) &&
        key.endsWith(SessionStorageService.MSAL_CACHED_RESPONSE_KEY_SUFFIX)
    );
  }

  public static clearMsalTemporaryCache(): void {
    Object.keys(sessionStorage)
      .filter(key =>
        key.startsWith(SessionStorageService.MSAL_TEMP_CACHE_PREFIX)
      )
      .forEach(key => sessionStorage.removeItem(key));
  }
}
